define([
    "./transitionSpreadsheetModule",
    "./transitionSpreadsheetService"
], function () {
});